<template>
  <header class="landing-header">
    <div class="header-gradient">
      <h1 class="header-title">Crypto Gift Cards</h1>

      <div class="powered-by">
        <span class="powered-by-text">Presented by</span>
        <img src="/landing/changelly_logo.svg" alt="Changelly" class="changelly-logo" />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
</script>

<style scoped>
.landing-header {
  width: 100%;
  height: 195px;
  background: #FFFFFF;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
}

.header-gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background: linear-gradient(71.45deg, #7091FF 3.16%, #2452EC 100%);
  background-size: 200% 200%;
  animation: gradientMove 8s ease infinite;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  gap: 8px;
}

/* Gift pattern background */
.header-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/landing/Gift.svg');
  background-size: 48px 48px;
  background-repeat: repeat;
  opacity: 0.15;
  transform: rotate(-15deg) scale(1.5);
  transform-origin: center;
  pointer-events: none;
}

.header-title {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  margin: 0;
  position: relative;
  z-index: 1;
  padding-top: 20px;
}

.powered-by {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  position: relative;
  z-index: 1;
}

.powered-by-text {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #FFFFFF;
}

.changelly-logo {
  width: 84px;
  height: 20px;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
